import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router";
import LoadingSpinner from "../../Components/Common/LoadingSpinner";
import {
  Transaction_LEGATE,
  Transaction_Login,
  Transaction_Profile,
} from "../../Connections/Transaction";
import Toast from "../../Utils/Toast";
import ChangeProfile from "../Profile/ChangeProfile";
import City from "../Profile/City";
import Education from "../Profile/Education";
import Province from "../Profile/Province";
import School from "../Profile/School";
import SchoolType from "../Profile/SchoolType";
import SafiranPage from "./safiran-page";

const AccountAmbassadors = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [linkValue, setLinkValue] = useState("");
  const [ceratedAccount, setCreatedAccount] = useState(false);

  //copy link
  const copyToClipBoard = async (text) => {
    await navigator.clipboard.writeText(text);
    Toast("success", "لینک با موفقیت کپی شد!");
  };

  const [ashnaiValue, setAshnaiValue] = useState();
  const [NiknameValue, setNiknameValue] = useState();
  const [dateBirthValue, setDateBirthValue] = useState();
  const [genderValue, setGenderValue] = useState();
  const [shahrValue, setShahrValue] = useState();
  const [educationValue, setEducationValue] = useState();
  const [schoolValue, setSchoolValue] = useState();
  const [emailValue, setEmailValue] = useState();
  const [addressValue, setAddressValue] = useState();
  const [codePostiValue, setCodePostiValue] = useState();
  const [schoolTypeValue, setSchoolTypeValue] = useState();
  const [MobileValue, setMobileValue] = useState();
  const [provinceID, setprovinceID] = useState();
  const [CityID, setCityID] = useState();
  const [schoolType, setSchoolType] = useState();
  const [school, setSchool] = useState();
  const [allowRules, setAllowRules] = useState(false);

  // ======================================================

  const [provinceList, setProvinceList] = useState({ options: [] });
  const [cityList, setCityList] = useState({ options: [] });

  // ======================================================

  const [ashnaiModal, setAshnaiModal] = useState(false);
  const [genderModal, setGenderModal] = useState(false);
  const [cityModal, setCityModal] = useState(false);
  const [educationModal, setEducationModal] = useState(false);
  const [schoolTypeModal, setSchoolTypeModal] = useState(false);
  const [schoolModal, setSchoolModal] = useState(false);
  const [selectedOption, setSelectedOption] = useState();
  const [ashnai, setAshnai] = useState({});
  const [selectedGenderOption, setSelectedGenderOption] = useState();
  const [gender, setGender] = useState({});
  const [education, setEducation] = useState({});
  const [selectedSchoolListOption, setSelectedSchoolListOption] = useState();
  const [selectedSchoolOption, setSelectedSchoolOption] = useState();
  const [UserInfo, setUserInfo] = useState({});
  const [DateYear, setDateYear] = useState([]);
  const [DateMonth, setDateMonth] = useState([]);
  const [DateDay, setDateDay] = useState([]);

  // =============================================================
  const [oflineProfileUrl, setOflineProfileUrl] = useState();
  const [changeProfileModal, setChangeProfileModal] = useState(false);
  const [submitLoading, setSubmitLoading] = useState(false);
  const [provinceModal, setProvinceModal] = useState(false);

  // =========================== submit data ==================================

  const [userName, setUserName] = useState("");
  const [userFamily, setUserFamily] = useState("");
  const [nationalCode, setNationalCode] = useState("");
  const [birthDay, setBirthDay] = useState([0, 0, 0]);
  const [LegateOrganizationId, setLegateOrganizationId] = useState(0);
  const [shabaCode, setShabaCode] = useState();
  //ostan
  const [stateValue, setStateValue] = useState("");
  //shahrestan
  const [cityValue, setCityValue] = useState("");
  const [selectedSchoolTypeOption, setSelectedSchoolTypeOption] = useState();
  //level school
  const [selectedEducationrOption, setSelectedEducationOption] = useState();
  const [roleSchool, setRoleSchool] = useState();
  const [profileImage, setProfileImage] = useState();
  const handleSubmitForm = (event) => {
    event.preventDefault();
    const form = new FormData();

    form.append("FirstName", userName);
    form.append("LastName", userFamily);
    form.append("NationalCode", nationalCode);
    form.append("DateOfBirth", birthDay.join("/"));
    form.append("LegateOrganizationId", LegateOrganizationId);
    if (LegateOrganizationId === 2 && shabaCode?.length === 24)
      form.append("ShabaCode", shabaCode);
    if (selectedSchoolOption != null && LegateOrganizationId === 1) {
      form.append("SchoolId", selectedSchoolOption.id);
    }
    if (LegateOrganizationId === 1)
      form.append("ResponsibilityAtSchool", roleSchool);
    form.append("NationalCardPic", profileImage);

    setSubmitLoading(true);
    Transaction_LEGATE.AddLegateProfile(form).then((res) => {
      if (res[0]) {
        Toast("success", "تغییرات با موفقیت انجام شد!");
        setSubmitLoading(false);
        navigate("/hisstori/safiran");
      } else {
        setSubmitLoading(false);
        Toast("error", res[1]);
      }
    });
  };

  // ======================== logout =============================

  const handleLogout = () => {
    Transaction_Login.Logout().then(
      (res) => (window.location = "/hisstori/safiran")
    );
  };

  const renderSchoolModal = () => {
    if (cityValue?.id) {
      if (selectedEducationrOption?.id) {
        if (selectedSchoolTypeOption?.id) {
          return (
            <School
              CityId={cityValue.id}
              GradeId={selectedEducationrOption.id}
              SchoolTypeId={selectedSchoolTypeOption.id}
              setEducationValue={setSchool}
              selectedEducationrOption={selectedSchoolOption}
              setSelectedEducationOption={setSelectedSchoolOption}
              close={() => setSchoolModal(false)}
            />
          );
        } else {
          Toast(
            "warning",
            "اول باید جنسیت و استان و شهرستان و نوع مدرسه و مقطع رو کامل کنی"
          );
        }
      } else {
        Toast(
          "warning",
          "اول باید جنسیت و استان و شهرستان و نوع مدرسه و مقطع رو کامل کنی"
        );
      }
    } else {
      Toast(
        "warning",
        "اول باید جنسیت و استان و شهرستان و نوع مدرسه و مقطع رو کامل کنی"
      );
    }
  };
  const range = (start, stop, step) => {
    if (typeof stop == "undefined") {
      stop = start;
      start = 0;
    }

    if (typeof step == "undefined") {
      step = 1;
    }

    if ((step > 0 && start >= stop) || (step < 0 && start <= stop)) {
      return [];
    }

    var result = [];
    for (var i = start; step > 0 ? i < stop : i > stop; i += step) {
      result.push(i);
    }

    return result;
  };

  //get data
  const [referalList, setReferalList] = useState();

  useEffect(() => {
    Transaction_LEGATE.GetLegateProfile().then((res) => {
      if (res[0]) {
        setCityValue({
          id: res[2].data.cityId,
          title: res[2].data.city,
        });
        setStateValue({
          id: res[2].data.provinceId,
          title: res[2].data.province,
        });
        setUserName(res[2].data.firstName);
        setUserFamily(res[2].data.lastName);
        setNationalCode(res[2].data.nationalCode);
        setBirthDay(res[2].data.dateOfBirth.split("/"));
        setLegateOrganizationId(res[2].data.legateOrganizationId);
        setShabaCode(res[2].data.shabaCode);
        setEducationValue({
          id: res[2].data.gradeId,
          name: res[2].data.grade,
        });
        setSelectedEducationOption({
          id: res[2].data.gradeId,
          name: res[2].data.grade,
        });
        setSchoolValue(res[2].data.school);
        setSchoolTypeValue({
          id: res[2].data.schoolTypeId,
          name: res[2].data.schoolType,
        });
        setSelectedSchoolTypeOption({
          id: res[2].data.schoolTypeId,
          name: res[2].data.schoolType,
        });
        setSelectedSchoolListOption({
          id: res[2].data.schoolTypeId,
          name: res[2].data.schoolType,
        });
        setSelectedSchoolOption({
          id: res[2].data.schoolId,
          name: res[2].data.school,
        });
        setRoleSchool(res[2].data.responsibilityAtSchool);
        setProfileImage(res[2].data.nationalCardPic);
      }
    });
    Transaction_LEGATE.GetLegateOrganizations().then((res) => {
      if (res[0]) {
        setReferalList(res[2].data);
      }
    });
  }, []);

  //get option for inputs

  useEffect(() => {
    var ProvinceIDTemp, CityIDtemp;
    setGender({
      options: [
        {
          id: 1,
          option: "دختر",
        },
        {
          id: 2,
          option: "پسر",
        },
      ],
    });

    Transaction_Profile.GetMethodOfIntroductions()
      .then((res) => {
        if (res[0]) {
          setAshnai({ options: res[2].data });
        }
      })
      .catch((err) => console.log(err));

    Transaction_Profile.GetGrades()
      .then((res) => {
        if (res[0]) {
          setEducation({ options: res[2].data });
        }
      })
      .catch((err) => console.log(err));

    Transaction_Profile.GetProfile().then((res) => {
      if (res[0]) {
        setUserInfo(res[2].data);
      } else {
        Toast("error", "مشکل در دریافت اطلاعات");
      }
    });

    Transaction_Profile.GetUserInfo().then((res) => {
      if (res[0]) {
        setSchoolValue(res[2].school);
        // setBirthDay(res[2].dateOfBirth.split("/"));
      }
    });

    Transaction_Profile.GetSchoolTypes()
      .then((res) => {
        if (res[0]) {
          setSchoolType({ options: res[2].data });
        }
      })
      .catch((err) => console.log(err));

    Transaction_Profile.GetProvinces()
      .then((res) => {
        if (res[0]) {
          setProvinceList({ options: res[2].data });
        }
      })
      .catch((err) => console.log(err));
  }, []);

  useEffect(() => {
    if (stateValue != undefined) {
      Transaction_Profile.GetCities(stateValue.id).then((res) => {
        if (res[0]) {
          setCityList({ options: res[2].data });
          if (CityID != null) {
            setCityValue(res[2].data.filter((city) => city.id == CityID)[0]);
          }
        }
      });
    }
  }, [stateValue]);

  //invite number
  const [inviteNumber, setInviteNumber] = useState("");

  const handleInviteNumber = () => {
    const form = new FormData();
    form.append("Mobile", inviteNumber);

    if (inviteNumber && inviteNumber.length === 11) {
      Transaction_LEGATE.AddLegateInvite(form).then((res) => {
        if (res[0]) {
          console.log(res);
          Toast("success", "دوست شما با موفقیت دعوت شد");
        } else {
          Toast("error", res[1]);
        }
      });
    } else {
      Toast("error", "لطفا شماره را درست وارد کنید");
    }
  };

  //my legate info
  const [myLegateInfo, setMyLegateInfo] = useState();

  useEffect(() => {
    Transaction_LEGATE.GetMyLegate().then((res) => {
      setCreatedAccount(res[0]);
      if (res[0]) {
        setMyLegateInfo(res[2].data);
        setLinkValue(res[2].data.myLink);
      }
    });
  }, []);

  return (
    <SafiranPage>
      {changeProfileModal ? (
        <ChangeProfile
          profilePicture={profileImage}
          setProfilePicture={setProfileImage}
          close={() => setChangeProfileModal(false)}
          setOflineProfileUrl={setOflineProfileUrl}
        />
      ) : null}
      {provinceModal ? (
        <Province
          setProvinceValue={setStateValue}
          provinceList={provinceList}
          selectedProvinceOption={stateValue}
          close={() => setProvinceModal(false)}
        />
      ) : null}
      {cityModal ? (
        <City
          setCityValue={setCityValue}
          cityList={cityList}
          setSelectedCityOption={cityValue}
          close={() => setCityModal(false)}
        />
      ) : null}
      {schoolTypeModal ? (
        <SchoolType
          setEducationValue={setSchoolTypeValue}
          EducationList={schoolType}
          selectedEducationrOption={selectedSchoolTypeOption}
          setSelectedEducationOption={setSelectedSchoolTypeOption}
          close={() => setSchoolTypeModal(false)}
        />
      ) : null}
      {educationModal ? (
        <Education
          setEducationValue={setEducationValue}
          EducationList={education}
          selectedEducationrOption={selectedEducationrOption}
          setSelectedEducationOption={setSelectedEducationOption}
          close={() => setEducationModal(false)}
        />
      ) : null}
      {schoolModal ? renderSchoolModal() : null}

      {/* header background */}
      <img
        className="header-bg-stars mobile-hidden"
        src={
          "https://ketabno.com/static/media/first-section-background.5913a5be96843bbb494e.svg"
        }
        alt="bg"
      />
      <img
        className="desktop-hidden header-star-mobile"
        src={"/imgs/ambassadors/1000000952.svg"}
        alt="bg"
      />
      {/* page body  */}
      <div
        className="wrapper-account-ambassadors"
        style={{ zIndex: 10, position: "relative" }}
      >
        <div className="header-account-detail">
          {ceratedAccount && (
            <h4
              style={{ marginBottom: "15px" }}
            >{`${userName} ${userFamily}`}</h4>
          )}
          <h3>{UserInfo.mobile}</h3>
          <button
            onClick={handleLogout}
            className="Profile-top-right-inside-button-getout"
          >
            خروج از حساب
          </button>
          {ceratedAccount && (
            <p className="title-select-invite">
              برای دعوت یکی از این ۲ راه را انتخاب کنید :)
            </p>
          )}
          {ceratedAccount && (
            <div
              style={{ paddingTop: "30px" }}
              className="InviteFriends-inside-item2-left-bottom-parent"
            >
              <div className="parent-input-box-invite">
                <p className="titile-invite-input-ambassadors">
                  وارد کردن شماره تلفن:
                </p>
                <div className="input-in-ambassadors">
                  <div
                    style={{ marginTop: "20px" }}
                    className="InviteFriends-inside-item2-left-bottom copyLink-ambassador"
                  >
                    <input
                      style={{ backgroundColor: "#010a2b" }}
                      className="InviteFriends-inside-item2-left-bottom-input InviteFriends-inside-item2-left-bottom-input-safiran"
                      type="tel"
                      maxLength={11}
                      id="inviteNumber"
                      required
                      value={inviteNumber}
                      onChange={(e) =>
                        isNaN(e.target.value)
                          ? null
                          : setInviteNumber(e.target.value)
                      }
                    />
                    <label
                      htmlFor="Link"
                      className="InviteFriends-inside-item2-left-bottom-label"
                    >
                      شماره تلفن
                    </label>
                    <button
                      onClick={handleInviteNumber}
                      style={{ backgroundColor: "#3A37E5" }}
                      className="InviteFriends-inside-item2-left-bottom-button"
                    >
                      ارسال دعوتنامه
                    </button>
                  </div>
                </div>
              </div>

              <div className="parent-input-box-invite">
                <p className="titile-invite-input-ambassadors">
                  کپی و ارسال لینک دعوت:
                </p>
                <div className="input-in-ambassadors">
                  <div
                    style={{ marginTop: "20px" }}
                    className="InviteFriends-inside-item2-left-bottom copyLink-ambassador"
                  >
                    <input
                      style={{ backgroundColor: "#010a2b" }}
                      className="InviteFriends-inside-item2-left-bottom-input InviteFriends-inside-item2-left-bottom-input-safiran"
                      type="text"
                      id="Link"
                      required
                      value={" "}
                    />

                    <span
                      className="link-ambasadors-input"
                      style={{
                        position: "absolute",
                        left: "50px",
                      }}
                    >
                      {linkValue}
                    </span>

                    <img
                      className="InviteFriends-inside-item2-left-bottom-icon"
                      src="/imgs/Profile/bx_link.svg"
                    />
                    <label
                      htmlFor="Link"
                      className="InviteFriends-inside-item2-left-bottom-label"
                    >
                      لینک دعوت
                    </label>
                    <button
                      className="InviteFriends-inside-item2-left-bottom-button"
                      onClick={() => copyToClipBoard(linkValue)}
                    >
                      کپی لینک
                    </button>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
        {ceratedAccount && (
          <div className="invitation-letter-box">
            <div className="invitation-letter-card">
              <div className="blur-color"></div>
              <div className="title-double-parent">
                <div className="title-lable-parent">
                  <div className="title-lable-box">کارنامه عملکرد شما</div>
                </div>
              </div>
              <div className="main-cadr">
                {/* 1 */}
                <div className="row-label">
                  <span className="title-label">تعداد دعوت‌های شما</span>
                  <div className="rate-lable">{myLegateInfo?.yourInviteNo}</div>
                </div>
                {/* 1 */}
                <div className="row-label">
                  <span className="title-label">تعداد مدال‌های تازه‌کار</span>
                  <div className="rate-lable">{myLegateInfo?.yourMedal1}</div>
                </div>
                {/* 1 */}
                <div className="row-label">
                  <span className="title-label">تعداد مدال‌های فعال</span>
                  <div className="rate-lable"> {myLegateInfo?.yourMedal2}</div>
                </div>
                {/* 1 */}
                <div className="row-label">
                  <span className="title-label">تعداد مدال‌های حرفه‌ای</span>
                  <div className="rate-lable"> {myLegateInfo?.yourMedal3}</div>
                </div>
              </div>
              <div className="foot-double-parent">
                <div className="title-lable-parent">
                  <div
                    style={{ flexDirection: "column" }}
                    className="title-lable-box"
                  >
                    <div>هدیه شما تا این لحظه!</div>
                    <div style={{ marginTop: "5px" }}>
                      {myLegateInfo?.yourGiftReceived} تومان
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
        {!ceratedAccount && (
          <div className="Edit-bottom Edit-bottom-ambassadors">
            <div className="Edit-bottom-inside Edit-bottom-inside-ambassadors">
              <p className="Edit-bottom-inside-titleForm">
                لطفا جهت دریافت لینک اختصاصی دعوت، ابتدا حساب کاربری خود را
                تکمیل کنید
              </p>
              <form
                onSubmit={handleSubmitForm}
                className="Edit-bottom-inside-form"
              >
                <div className="Edit-bottom-inside-form-item">
                  <div className="Edit-bottom-inside-form-div">
                    <input
                      autocomplete="off"
                      className="Edit-bottom-inside-form-div-input"
                      type="text"
                      name="name"
                      id="name"
                      onChange={(e) => setUserName(e.target.value)}
                      value={userName}
                    />
                    <label
                      htmlFor="number"
                      className="Edit-bottom-inside-form-div-label-star"
                    >
                      نام
                    </label>
                  </div>
                  <div className="Edit-bottom-inside-form-div div-left">
                    <input
                      autocomplete="off"
                      className="Edit-bottom-inside-form-div-input"
                      type="text"
                      name="name"
                      id="name"
                      onChange={(e) => setUserFamily(e.target.value)}
                      value={userFamily}
                    />
                    <label
                      htmlFor="name"
                      className="Edit-bottom-inside-form-div-label-star"
                    >
                      نام خانوادگی
                    </label>
                  </div>
                </div>
                <div className="Edit-bottom-inside-form-item">
                  <div className="Edit-bottom-inside-form-div">
                    <input
                      autocomplete="off"
                      className="Edit-bottom-inside-form-div-input ambassador-input-place-holder number-font number"
                      type="text"
                      name="number"
                      id="number"
                      placeholder="لطفا کد ملی ۱۰‌ رقمی خود را وارد کنید"
                      value={nationalCode}
                      onChange={(e) => setNationalCode(e.target.value)}
                    />
                    <label
                      htmlFor="number"
                      className="Edit-bottom-inside-form-div-label-star"
                    >
                      کد ملی
                    </label>
                  </div>
                  <div className="Edit-bottom-inside-form-div div-left Edit-birthDayWrapper">
                    <diiv className="Edit_profile_divData">
                      <select
                        id="ddlday"
                        className="DateBirthDropDown"
                        value={birthDay[2]}
                        onChange={(e) =>
                          setBirthDay([
                            birthDay[0],
                            birthDay[1],
                            e.target.value,
                          ])
                        }
                      >
                        <option value={0}>روز</option>
                        {range(0, 32).map((day) => (
                          <option value={day}>{day}</option>
                        ))}
                      </select>
                      <select
                        id="ddlmonth"
                        className="DateBirthDropDown"
                        value={birthDay[1]}
                        onChange={(e) =>
                          setBirthDay([
                            birthDay[0],
                            e.target.value,
                            birthDay[2],
                          ])
                        }
                      >
                        <option value={0}>ماه</option>
                        <option value={1}>فروردین</option>
                        <option value={2}>اردیبهشت</option>
                        <option value={3}>خرداد</option>
                        <option value={4}>تیر</option>
                        <option value={5}>مرداد</option>
                        <option value={6}>شهریور</option>
                        <option value={7}>مهر</option>
                        <option value={8}>آبان</option>
                        <option value={9}>آذر</option>
                        <option value={10}>دی</option>
                        <option value={11}>بهمن</option>
                        <option value={12}>اسفند</option>
                      </select>
                      <select
                        id="ddlYears"
                        className="DateBirthDropDown"
                        value={birthDay[0]}
                        onChange={(e) =>
                          setBirthDay([
                            e.target.value,
                            birthDay[1],
                            birthDay[2],
                          ])
                        }
                      >
                        <option value={0}>سال</option>
                        {range(1330, 1401).map((year) => (
                          <option value={year}>{year}</option>
                        ))}
                      </select>
                    </diiv>
                    <label
                      htmlFor="DateBirth"
                      className="Edit-bottom-inside-form-div-label-star label-datepicker"
                    >
                      تاریخ تولد
                    </label>
                  </div>
                </div>

                <div className="Edit-bottom-inside-form-item">
                  <div className="Edit-bottom-inside-form-div">
                    <select
                      style={{
                        paddingTop: "0px",
                        paddingBottom: "0px",
                        direction: "rtl",
                      }}
                      className="Login_wrapper-right-side-container-form-input-number input-account-ambassadors b-none"
                      name="cars"
                      id="cars"
                      onChange={(e) =>
                        setLegateOrganizationId(Number(e.target.value))
                      }
                      value={LegateOrganizationId}
                    >
                      <option value="">معرفی شده توسط</option>
                      {referalList?.map((item) => {
                        return (
                          <option key={item.id} value={item.id}>
                            {item.name}
                          </option>
                        );
                      })}
                    </select>
                  </div>
                  {LegateOrganizationId === 0 && (
                    <div className="Edit-bottom-inside-form-div div-left">
                      <div className="parent-guide-box">
                        <img
                          className="arrow-icon-ambassadors mobile-hidden"
                          src="imgs/ambassadors/arrow-icon.svg"
                          alt=""
                        />
                        <img
                          className="warning-icon-ambassadors mobile-hidden"
                          src="imgs/ambassadors/warning-icon.svg"
                          alt=""
                        />
                        <img
                          className="warning-icon-ambassadors desktop-hidden"
                          src="imgs/ambassadors/warning-icon-light.svg"
                          alt=""
                        />
                        <p className="text-warning-ambassadors">
                          در صورتی که جزء کادر رسمی مدارس هستید گزینه‌ی «مدرسه»
                          و در غیر این‌صورت نام نهاد یا سـازمانی که توسط آن
                          معرفی شده‌اید را انتخاب کنید.
                        </p>
                      </div>
                    </div>
                  )}
                  {LegateOrganizationId === 1 && (
                    <div className="Edit-bottom-inside-form-div div-left">
                      <div
                        className="Edit-bottom-inside-form-div-border"
                        onClick={() => setProvinceModal(true)}
                      >
                        <div className="Edit-bottom-inside-form-div-border-inside">
                          <label
                            htmlFor="Ashnai"
                            className="Edit-bottom-inside-form-div-border-inside-label"
                          >
                            استان
                          </label>
                        </div>
                        <p className="Edit-bottom-inside-form-div-border-inside-text">
                          {stateValue ? stateValue.title : ""}
                        </p>
                        <img
                          className="Edit-bottom-inside-form-div-icon"
                          src="imgs/Profile/icon-edit.svg"
                        />
                      </div>
                    </div>
                  )}

                  {LegateOrganizationId !== 0 && LegateOrganizationId !== 1 && (
                    <div className="Edit-bottom-inside-form-div div-left">
                      <input
                        autocomplete="off"
                        className="Edit-bottom-inside-form-div-input ambassador-input-place-holder"
                        type="text"
                        name="name"
                        id="name"
                        onChange={(e) => setShabaCode(e.target.value)}
                        value={shabaCode}
                        placeholder="لطفا شماره 24 رقمی شبای بانکی خود را وارد کنید"
                        maxLength={24}
                      />
                      <span className="shaba-label">IR</span>
                      <label
                        htmlFor="number"
                        className="Edit-bottom-inside-form-div-label-star"
                      >
                        شماره شبا
                      </label>
                    </div>
                  )}
                </div>
                <div className="Edit-bottom-inside-form-item">
                  {LegateOrganizationId === 1 && (
                    <div className="Edit-bottom-inside-form-div">
                      <div
                        className="Edit-bottom-inside-form-div-border"
                        onClick={() => setCityModal(true)}
                      >
                        <div className="Edit-bottom-inside-form-div-border-inside">
                          <label
                            htmlFor="Ashnai"
                            className="Edit-bottom-inside-form-div-border-inside-label"
                          >
                            شهرستان یا منطقه آموزش و پرورش
                          </label>
                        </div>
                        <p className="Edit-bottom-inside-form-div-border-inside-text">
                          {cityValue ? cityValue.title : ""}
                        </p>
                        <img
                          className="Edit-bottom-inside-form-div-icon"
                          src="imgs/Profile/icon-edit.svg"
                        />
                      </div>
                    </div>
                  )}
                  <div className="Edit-bottom-inside-form-div  div-left">
                    {LegateOrganizationId === 1 && (
                      <div
                        className="Edit-bottom-inside-form-div-border"
                        onClick={() => setSchoolTypeModal(true)}
                      >
                        <div className="Edit-bottom-inside-form-div-border-inside">
                          <label
                            htmlFor="Ashnai"
                            className="Edit-bottom-inside-form-div-border-inside-label"
                          >
                            نوع مدرسه
                          </label>
                        </div>
                        <p className="Edit-bottom-inside-form-div-border-inside-text">
                          {schoolTypeValue?.name}
                        </p>
                        <img
                          className="Edit-bottom-inside-form-div-icon"
                          src="imgs/Profile/icon-edit.svg"
                        />
                      </div>
                    )}
                  </div>
                </div>
                {LegateOrganizationId === 1 && (
                  <div className="Edit-bottom-inside-form-item">
                    <div className="Edit-bottom-inside-form-div">
                      <div
                        className="Edit-bottom-inside-form-div-border"
                        onClick={() => setEducationModal(true)}
                      >
                        <div className="Edit-bottom-inside-form-div-border-inside">
                          <label
                            htmlFor="Ashnai"
                            className="Edit-bottom-inside-form-div-border-inside-label"
                          >
                            مقطع تحصیلی
                          </label>
                        </div>
                        <p className="Edit-bottom-inside-form-div-border-inside-text">
                          {educationValue?.name}
                        </p>
                        <img
                          className="Edit-bottom-inside-form-div-icon"
                          src="imgs/Profile/icon-edit.svg"
                        />
                      </div>
                    </div>
                    <div className="Edit-bottom-inside-form-div div-left">
                      <div
                        className="Edit-bottom-inside-form-div-border"
                        onClick={(e) => {
                          if (renderSchoolModal()) {
                            setSchoolModal(true);
                          } else {
                            console.log(e.target);
                            e.target.blur();
                          }
                        }}
                      >
                        <div className="Edit-bottom-inside-form-div-border-inside">
                          <label
                            htmlFor="Ashnai"
                            className="Edit-bottom-inside-form-div-border-inside-label"
                          >
                            نام مدرسه
                          </label>
                        </div>
                        <p className="Edit-bottom-inside-form-div-border-inside-text">
                          {selectedSchoolOption?.name}
                        </p>
                        <img
                          className="Edit-bottom-inside-form-div-icon"
                          src="imgs/Profile/icon-edit.svg"
                        />
                      </div>
                    </div>
                  </div>
                )}
                {LegateOrganizationId === 1 && (
                  <div className="Edit-bottom-inside-form-item">
                    <div className="Edit-bottom-inside-form-div">
                      <input
                        autocomplete="off"
                        className="Edit-bottom-inside-form-div-input"
                        type="text"
                        name="name"
                        id="name"
                        onChange={(e) => setRoleSchool(e.target.value)}
                        value={roleSchool}
                      />
                      <label
                        htmlFor="number"
                        className="Edit-bottom-inside-form-div-label-star"
                      >
                        مسئولیت در مدرسه
                      </label>
                    </div>
                    <div className="Edit-bottom-inside-form-div div-left"></div>
                  </div>
                )}
                <div style={{ display: "flex", justifyContent: "center" }}>
                  <div className="Edit-bottom-inside-form-item parent-foot-account-ambassadors">
                    <div
                      onClick={() => setChangeProfileModal(true)}
                      className="card-img-box"
                    >
                      {!profileImage ? (
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                          }}
                        >
                          {window.outerWidth > 768 ? (
                            <img
                              src="/imgs/ambassadors/upload-svg.svg"
                              alt="upload"
                            />
                          ) : (
                            <img
                              src="/imgs/ambassadors/upload-svg-light.svg"
                              alt="upload"
                            />
                          )}
                          <div>
                            <p>تصویر روی کارت ملی خود را بارگذاری کنید</p>
                            <h5>حجم عکس باید کمتر از ۱ مگابایت باشد</h5>
                          </div>
                        </div>
                      ) : (
                        <img
                          style={{ width: "100%", height: "100%" }}
                          src={
                            oflineProfileUrl !== undefined
                              ? oflineProfileUrl
                              : profileImage
                          }
                          alt="card"
                        />
                      )}
                    </div>
                    <p className="detail-card-ambassadors">
                      انجام ثبت‌نام به منزله پذیرش مسئولیت صحت اطلاعات وارد شده
                      و قبول تـمامی قوانـین و مـقررات است
                    </p>
                    <div
                      style={{ marginRight: "0px" }}
                      className="Edit-bottom-inside-form-div div-left"
                    >
                      {submitLoading ? (
                        <span className="Edit-bottom-inside-form-submit-input w-100">
                          <LoadingSpinner />
                        </span>
                      ) : (
                        <input
                          autocomplete="off"
                          className="Edit-bottom-inside-form-submit-input Edit-bottom-inside-form-submit-input-account-ambassador w-100"
                          type="submit"
                          value="تکمیل حساب کاربری و ذخیره اطلاعات"
                        />
                      )}
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        )}
      </div>
    </SafiranPage>
  );
};

export default AccountAmbassadors;
